import CountryFlag from "@/components/relations/flag-icon";
import { supported_language_list } from "@/i18n";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const languageValues = {
	de: "DE",
	en: "EN",
	nl: "NL",
};

export default function InputSelectLanguage({ sx = null, size = "medium" }) {
	const { i18n } = useTranslation();
	const [anchorEl, setAnchorEl] = useState(null);
	const router = useRouter();
	const open = Boolean(anchorEl);

	/* -------------------------------- HANDLERS -------------------------------- */
	const clickHandler = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const onSelectHandler = (event, countryCode) => {
		setAnchorEl(event.currentTarget);
		i18n.changeLanguage(countryCode);
		setAnchorEl(null);
	};
	const closeHandler = () => {
		setAnchorEl(null);
	};

	/* -------------------------------- LISTENERS ------------------------------- */
	useEffect(() => {
		if (router.isReady && router?.query?.lang) {
			const languageParam = router.query.lang.toLowerCase();

			if (i18n.language !== languageParam && supported_language_list.includes(languageParam)) {
				i18n.changeLanguage(languageParam);
			}
		}
	}, [router, i18n]);

	return (
		<>
			<Button
				aria-haspopup="true"
				aria-expanded={open}
				color="company_light"
				onClick={clickHandler}
				variant="contained"
				size={size}
				endIcon={<ArrowDropDownIcon />}
				sx={sx}
			>
				<CountryFlag width={24} height={24} country_code={i18n.language} />
				<Box>{languageValues[i18n.language]}</Box>
			</Button>

			<Menu
				anchorOrigin={{
					horizontal: "left",
					vertical: "bottom",
				}}
				transformOrigin={{
					horizontal: "left",
					vertical: "top",
				}}
				anchorEl={anchorEl}
				open={open}
				onClose={closeHandler}
			>
				<LanguageOption country_code="nl" on_select_handler={onSelectHandler} />
				<LanguageOption country_code="en" on_select_handler={onSelectHandler} />
				<LanguageOption country_code="de" on_select_handler={onSelectHandler} />
			</Menu>
		</>
	);
}

/* ----------------------------- LANGUAGE OPTION ---------------------------- */
function LanguageOption({ country_code, on_select_handler }) {
	return (
		<MenuItem onClick={(event) => on_select_handler(event, country_code)} value={country_code}>
			<Box display="flex" alignItems="center">
				<CountryFlag width={24} height={24} country_code={country_code} />
				<Box component="span" fontWeight={500}>
					{languageValues[country_code]}
				</Box>
			</Box>
		</MenuItem>
	);
}
